import { connect } from 'react-redux'

import { changeTeam } from 'app/session/session_actions'
import { fetchAdvertisement } from 'app/sm/advertisements/advertisement_actions'
import Preferences from 'app/sm/ppp/property_components/preferences/preferences'
import {
  cancelModal,
  fetchProfile,
  fetchProperty,
  ping,
  shouldUpdateAd,
  steps,
  update,
  updateField,
} from 'app/sm/profile/profile_actions'

const mapStateToProps = ({ Profile, Advertisements, session }) => ({
  error: Profile.error,
  profile: Profile.profile,
  spinner: Profile.spinner,
  steps,
  modal: Profile.modal,
  offer: Advertisements.advertisement,
  responseText: Profile.responseText,
  teams: session.teams,
})

const mapDispatchToProps = (dispatch) => ({
  ping: () => dispatch(ping()),
  update: (step, data) => dispatch(update(step, data)),
  fetchProfile: (offerId) => dispatch(fetchProfile(offerId)),
  updateField: (key, val) => dispatch(updateField(key, val)),
  fetchProperty: (slug) => dispatch(fetchProperty(slug)),
  fetchOffer: (offerId) => fetchAdvertisement(offerId),
  shouldUpdateAd: (propertyId, should) =>
    dispatch(shouldUpdateAd(propertyId, should)),
  cancelModal: () => dispatch(cancelModal()),
  changeTeam: (currentTeam) => dispatch(changeTeam(currentTeam)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Preferences)
